/* @flow */

import PropTypes from 'prop-types';
import Immutable from 'immutable';
//import { routerShape, locationShape } from 'react-router/lib/PropTypes';

export default Object.assign({}, PropTypes, {

  immutable: {
    iterable: PropTypes.instanceOf(Immutable.Iterable),
    map: PropTypes.instanceOf(Immutable.Map),
    list: PropTypes.instanceOf(Immutable.List),
    set: PropTypes.instanceOf(Immutable.Set),
    orderedmap: PropTypes.instanceOf(Immutable.OrderedMap)
  },

  false: PropTypes.oneOf([false]),
  true: PropTypes.oneOf([true]),

  //router: routerShape,
  //location: locationShape,

  listOrFunc: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.instanceOf(Immutable.List)
  ])

});
